// extracted by mini-css-extract-plugin
export var breadCrumbIcon = "m_2";
export var breadcrumbElement = "m_Y";
export var heroMargins = "m_1";
export var listBreadcrumb = "m_0";
export var listBreadcrumbModeDark = "m_Z";
export var listBreadcrumbModeLight = "m_X";